import { bilingPriceInitConst } from "constants/console/billingquery/billingConst";
import { atom } from "recoil";
import { calcInitCalcInfo } from "hooks/biling/useBilingCalc";

/**
 * @desc 요금 조회 데이터
 * 페이지 새로고침시에만 API를 가지고 오기 위한 변수
 */
export const paymentState = atom({
  key: "paymentState",
  default: {
    data: bilingPriceInitConst,
    isLoading: false,
  },
});

/**
 * @desc 청구 내역 데이터
 * 페이지 새로고침시에만 API를 가지고 오기 위한 변수
 */
export const doneState = atom({
  key: "doneState",
  default: {
    data: {
      payment: bilingPriceInitConst,
      card: null,
      paymentAppList: [],
    },
    isLoading: false,
  },
});

/**
 * @desc 미납 내역 데이터
 * 페이지 새로고침시에만 API를 가지고 오기 위한 변수
 */
export const cancelState = atom({
  key: "cancelState",
  default: {
    data: {
      payment: bilingPriceInitConst,
      card: null,
      paymentAppList: [],
    },
    isLoading: false,
  },
});

/**
 * @desc 카드 정보 데이터
 * 페이지 새로고침시에만 API를 가지고 오기 위한 변수
 */
export const cardState = atom({
  key: "cardState",
  default: {
    isLoading: false,
    isRegister: false,
    info: null,
  },
});

/**
 * @desc 이용 상품 관리 데이터
 * 페이지 새로고침시에만 API를 가지고 오기 위한 변수
 */
export const productState = atom({
  key: "productState",
  default: {
    isLoading: false,
    list: [],
  },
});

/**
 * @desc 요금 계산하기 상태
 */
export const bilingPlanCalcState = atom({
  key: "bilingPlanCalcState",
  default: calcInitCalcInfo(),
});
